<div class="mon-dialog-header">
    <page-header
            icon="fas fa-copy"
            header="{{ 'Page links' | translate }}"
            [subHeader]="(links.total | monNumber) + ' ' + ('result' | translateWithPlural:links.total:'results')">
    </page-header>
</div>
<div class="mon-dialog-body pt-6 px-3">
    <mon-tabs
            [showSearch]="true"
            [options]="tabs"
            (onStatus)="onStatus($event)"
            [(status)]="activeTab"
            (onSearch)="onSearch($event)"
            [search]="search"
            [minSearchLength]="1">
        <csv-export-button *ngIf="activeTab === 'internal'" [exports]="export"></csv-export-button>
        <csv-export-button *ngIf="activeTab === 'external'" [exports]="exports"></csv-export-button>
    </mon-tabs>
    <div class="card panel-monsido-card">
        <div class="card-body">
            <div class="mx-4">
                <table-container [collection]="links"
                                 (onPageChange)="onPageChange($event)"
                                 (onPerPageChange)="onPageSizeChange($event)"
                                 [progress]="promise">
                    <table class="table table-hover table-fixed">
                        <thead>
                        <tr>
                            <th class="col-sm-24 col-md-32 col-lg-36" translate>URL</th>
                            <th class="col-sm-12 col-md-8 col-lg-6 text-right" *ngIf="scanDocuments"></th>
                            <th class="col-sm-12 col-md-8 col-lg-6 text-right"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let link of links">
                            <td class="text-v-middle text-ellipsis">
                                <a class="inline-block text-ellipsis text-nowrap max-width" [href]="link.url" target="_blank" [attr.aria-describedby]="'linkOpensInNewTab'">{{ link.url }}</a>
                            </td>
                            <td class="text-v-middle text-right" [attr.aria-label]="'Documents' | translate" *ngIf="scanDocuments">
                                <pages-button
                                    [text]="'Document' | translate"
                                    [textPlural]="'Documents' | translate"
                                    (callback)="openDialog(link, 'document')"
                                    [ngModel]="link.documents_count">
                                </pages-button>
                            </td>
                            <td class="text-v-middle text-right" [attr.aria-label]="'Pages' | translate">
                                <pages-button
                                    (callback)="openDialog(link)"
                                    [monAriaLabel]="'Show pages with this link' | translate"
                                    [ngModel]="link.html_pages_count">
                                </pages-button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </table-container>
            </div>
        </div>
    </div>
</div>
